import React, { useState } from 'react';
import ConfirmModal from '../../partials/confirm-modal';
import { useDeleteData, useDeleteSwap } from '../../hooks/api-hooks';
import { queryClient } from '../../app';

export default function PrivacyTab() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteUserDataMutation = useDeleteData();

  const handleDeleteAccount = async () => {
    setIsDeleting(true);
    await deleteUserDataMutation.mutateAsync();
    await queryClient.invalidateQueries({ queryKey: ['getUser', 'getCurrentPersonaSession'] });
    setIsDeleting(false);
    setShowDeleteModal(false);
  };

  return (
    <div className="max-w-3xl py-8 px-4 sm:px-6 lg:px-8">
      <div className='text-sm text-gray-500'>
        <p className='mt-2'>
          Deleting your data will permanently remove:
        </p>
        <ul className='mt-4 space-y-2 list-disc list-inside'>
          <li>Any original image & video you uploaded</li>
          <li>Generated faces (anonymized content)</li>
        </ul>
      </div>

      <button
        className='mt-6 px-4 py-2 text-white bg-red-600 hover:bg-red-700 rounded-md text-sm font-medium'
        onClick={() => setShowDeleteModal(true)}
      >
        Delete My Data
      </button>

      {/* Delete Confirmation Modal */}
      <ConfirmModal
        isOpen={showDeleteModal}
        onConfirm={handleDeleteAccount}
        onCancel={() => setShowDeleteModal(false)}
        message="Are you sure you want to delete all your data? All your data will be permanently removed. This action cannot be undone."
      />
    </div>
  );
}
